module.exports = __webpack_public_path__ + "img/login_bg.50248b53.jpg";